<ng-container>
   <div
      *ngIf="isCaptain"
      class="d-flex flex-row mb-2"
      style="justify-content: end">
      <div
         class="dropdown action-label flex-column ml-2"
         style="margin-top: -12px">
         <div style="margin-bottom: 2px; margin-left: 13px; text-align: left; font-size: 9.5px; font-weight: 400; color: #7c7c7c; font-style: italic">
            Writeback Status
         </div>
         <a
            href="javascript:void(0);"
            class="btn btn-white btn-sm btn-rounded dropdown-toggle writebackStatusDrop"
            data-bs-toggle="dropdown">
            <i
               class="fa-regular fa-circle-dot me-1"
               [ngClass]="
                  writebackStatusFilterText == 'All Statuses'
                     ? 'text-info'
                     : writebackStatusFilterText == 'Pending'
                     ? 'text-muted'
                     : writebackStatusFilterText == 'Error'
                     ? 'text-danger'
                     : writebackStatusFilterText == 'Skipped'
                     ? 'text-warning'
                     : 'text-success'
               "></i>
            &nbsp;{{ writebackStatusFilterText }}
         </a>

         <div class="dropdown-menu">
            <a
               href="javascript:void(0);"
               (click)="setWritebackStatusFilter(null, 'All Statuses')"
               class="dropdown-item">
               <i class="fa-regular fa-circle-dot text-info me-1"></i>
               &nbsp;All Statuses
            </a>
            <a
               href="javascript:void(0);"
               (click)="setWritebackStatusFilter(0, 'Pending')"
               class="dropdown-item">
               <i class="fa-regular fa-circle-dot text-muted me-1"></i>
               &nbsp;Pending
            </a>
            <a
               href="javascript:void(0);"
               (click)="setWritebackStatusFilter(1, 'Error')"
               class="dropdown-item">
               <i class="fa-regular fa-circle-dot text-danger me-1"></i>
               &nbsp;Error
            </a>
            <a
               href="javascript:void(0);"
               (click)="setWritebackStatusFilter(2, 'Success')"
               class="dropdown-item">
               <i class="fa-regular fa-circle-dot text-success me-1"></i>
               &nbsp;Success
            </a>
            <a
               href="javascript:void(0);"
               (click)="setWritebackStatusFilter(4, 'Skipped')"
               class="dropdown-item">
               <i class="fa-regular fa-circle-dot text-warning me-1"></i>
               &nbsp;Skipped
            </a>
         </div>
      </div>

      <div
         *ngIf="!isRequestView"
         class="flex-column ml-2 v-dropdown-sm">
         <p-dropdown
            [filter]="true"
            placeholder="PIMS Category"
            [options]="productCategories()"
            [(ngModel)]="productCategoryFilter"
            ngModelOptions="{standalone: true}"
            name="productCategoryFilter"
            [class.v-categoryfilter]="true"></p-dropdown>
      </div>

      <div
         *ngIf="isRequestView"
         class="flex-column ml-2 v-dropdown-sm">
         <p-dropdown
            [filter]="true"
            placeholder="Search by Practice"
            [options]="uniquePractices()"
            [(ngModel)]="productPracticeFilter"
            ngModelOptions="{standalone: true}"
            name="productPracticeFilter"
            [class.v-sitefilter]="true"></p-dropdown>
      </div>

      <div class="flex-column ml-2 v-dropdown-sm">
         <p-dropdown
            [options]="productTypeOptions"
            placeholder="All Types"
            [(ngModel)]="productTypeFilter"
            ngModelOptions="{standalone: true}"
            name="productTypeFilter"
            [class.v-typefilter]="true"></p-dropdown>
      </div>
   </div>

   <div
      class="d-flex flex-row mt-1 mb-1"
      style="justify-content: end">
      <div
         *ngIf="siteCount() > 2"
         class="flex-column ml-2 v-dropdown-sm">
         <p-dropdown
            [filter]="true"
            placeholder="Search by Site"
            [options]="sites()"
            [(ngModel)]="selectedSite"
            ngModelOptions="{standalone: true}"
            name="siteFilter"
            [class.v-sitefilter]="true"></p-dropdown>
      </div>

      <div class="flex-column ml-2 v-searchbox-sm v-productfilter">
         <input
            pInputText
            [(ngModel)]="productNameFilter"
            ngModelOptions="{standalone: true}"
            name="productNameFilter"
            placeholder="Search by product" />
      </div>
      <div class="flex-column ml-2 v-searchbox-sm v-codefilter">
         <input
            pInputText
            [(ngModel)]="codeFilterValue"
            ngModelOptions="{standalone: true}"
            name="codeFilterValue"
            placeholder="Search by code" />
      </div>
      <div
         *ngIf="!isCaptain"
         class="flex-column ml-2 v-dropdown-sm">
         <p-dropdown
            [filter]="true"
            placeholder="PIMS Category"
            [options]="productCategories()"
            [(ngModel)]="productCategoryFilter"
            ngModelOptions="{standalone: true}"
            name="productCategoryFilter"
            [class.v-categoryfilter]="true"></p-dropdown>
      </div>
      <div
         *ngIf="!isCaptain"
         class="flex-column ml-2 v-dropdown-sm">
         <p-dropdown
            [options]="productTypeOptions"
            placeholder="All Types"
            [(ngModel)]="productTypeFilter"
            ngModelOptions="{standalone: true}"
            name="productTypeFilter"
            [class.v-typefilter]="true"></p-dropdown>
      </div>
   </div>

   <div
      *ngIf="isCaptain"
      class="text-right pendingReviewCheck">
      <label>
         <input
            type="checkbox"
            [checked]="pendingReview()"
            (change)="pendingReview.set($event.target.checked)" />
         Pending Review
      </label>
   </div>

   <div
      class="pricing-manager-table"
      style="background: #f7f7f7"
      [class.loading]="loading()">
      <vc-spinner *ngIf="loading()"></vc-spinner>

      <div
         *ngIf="!loading()"
         class="table-responsive mt-2"
         style="overflow-y: auto; position: relative">
         <table
            matSort
            class="table custom-table datatable contact-table"
            style="width: 100%; border-collapse: collapse; margin-bottom: 2px"
            (matSortChange)="sortModel.set($event)">
            <thead style="position: sticky; top: 0; z-index: 10; background-color: #fff">
               <tr
                  *ngIf="!loading()"
                  class="pricingTableHeaders">
                  <vetcor-pricing-table-headers
                     [isRequestView]="isRequestView"
                     [showPracticeColumn]="showPracticeColumn()"
                     [displayAsReview]="isCaptain"
                     [siteCount]="siteCount()" />
               </tr>
            </thead>

            <cdk-virtual-scroll-viewport
               *ngIf="!loading()"
               [itemSize]="60"
               [ngClass]="{
                  'example-viewport': !isRequestView,
                  'example-viewport-pricing-admin': isRequestView && isCaptain,
                  'example-viewport-pricing': isRequestView && !isCaptain
               }"
               style="overflow-y: scroll; border-top: 2px solid #dee2e6">
               <tbody class="dashboardFaxRows pricingTableHeadersBody">
                  <ng-container *cdkVirtualFor="let row of sortedRows(); let last = last; trackBy: trackByFn">
                     <vetcor-pricing-row
                        style="width: 100%"
                        [row]="row"
                        [isRequestView]="isRequestView"
                        [showPracticeColumn]="showPracticeColumn()"
                        [displaySites]="siteCount() > 2 && !isRequestView"
                        [displayAsReview]="isCaptain"></vetcor-pricing-row>
                  </ng-container>
               </tbody>
            </cdk-virtual-scroll-viewport>
         </table>
      </div>
   </div>

   <button
      id="areyousureButton"
      data-bs-toggle="modal"
      data-bs-target="#areyousure"
      style="display: none"></button>

   <vc-reject-price-modal
      [rejectProduct]="rejectProduct"
      (onRowSave)="onRowSave($event)" />

   <vc-validation-warning-modal />
</ng-container>
